'use client';

import React, { useMemo } from 'react';
import FieldRenderer from '@/components/Common/Form/fields/FieldRenderer';
import { buildOptionsField } from './feedbackFormFields';
import type { FeedbackOption } from './types';

type FeedbackOptionsStepProps = {
  options: FeedbackOption[];
  error?: string;
};

const FeedbackOptionsStep = ({ options, error }: FeedbackOptionsStepProps) => {
  const field = useMemo(() => buildOptionsField(options), [options]);

  return (
    <div className="it-feedback-options">
      <FieldRenderer field={field} error={error} />
    </div>
  );
};

export default FeedbackOptionsStep;
